import { render, staticRenderFns } from "./About.vue?vue&type=template&id=28550350"
import script from "./About.vue?vue&type=script&setup=true&lang=js"
export * from "./About.vue?vue&type=script&setup=true&lang=js"
import style0 from "./About.vue?vue&type=style&index=0&id=28550350&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports